export const SN_PARTNERS = 'partners'
export const PARTNERS_SET_PARTNERS = `${SN_PARTNERS}/PARTNERS_SET_PARTNERS`
